<div class="intro-y mt-2 flex flex-col items-center sm:flex-row">
  <div class="flex mr-2 w-full sm:mt-0 sm:w-auto">
    <button (click)="Atras()" [class]="styleListSmallButtonRoundedSecondary" class="rounded-full tooltip"
      data-placement="top" data-tw-merge="" title="Regresar"><i [class]="styleIconButtonSmall" data-lucide="arrow-left"
        data-tw-merge=""></i></button>
  </div>
  <h2 class="mr-auto text-lg font-medium">NOTIFICACIONES</h2>
</div>
<!--  <div class="grid grid-cols-12 gap-5">-->
<!--    <div class="col-span-12 lg:col-span-2"></div>-->
<!--    &lt;!&ndash; BEGIN: Chat Content &ndash;&gt;-->
<!--    <div class="col-span-12 lg:col-span-8">-->
<!--      <div class="chat-box box">-->
<!--        &lt;!&ndash; BEGIN: Chat Active &ndash;&gt;-->
<!--        <div class="flex items-center border-t border-slate-200/60 pb-10 pt-4 dark:border-darkmode-400 sm:py-4">-->
<!--          <form [formGroup]="dataFormGroup" autocomplete="off" class="w-full form" novalidate="novalidate">-->
<!--            <div class="p-5 grid grid-cols-7 gap-5">-->
<!--              <div class="col-span-12">-->
<!--                <div class="flex group input-group" data-tw-merge inputGroup="inputGroup">-->
<!--                  <div class="py-2 px-3 bg-slate-100 border shadow-sm border-slate-200 text-slate-600 dark:bg-darkmode-900/20 dark:border-darkmode-900/20 dark:text-slate-400 group-[.input-group]:rounded-none group-[.input-group]:[&:not(:first-child)]:border-l-transparent group-[.input-group]:first:rounded-l group-[.input-group]:last:rounded-r"-->
<!--                       data-tw-merge>-->
<!--                    +51-->
<!--                  </div>-->
<!--                  <input (keypress)="FiltrarNumeros($event)" [class]="styleInputText" data-tw-merge=""-->
<!--                         formControlName="inputNumeroDestino" maxlength="9" placeholder="Escriba número destino">-->
<!--                </div>-->
<!--                <div-->
<!--                  *ngIf="Controls['inputNumeroDestino'].invalid && (Controls['inputNumeroDestino'].dirty || Controls['inputNumeroDestino'].touched)"-->
<!--                  class="text-error">-->
<!--                  <div>Campo obligatorio.</div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="col-span-12 text-center">-->
<!--                <button (click)="TriggerFile(fileInput,true,false,false,false)" [class]="styleListSmallButtonRoundedPrimary" class="rounded-full"-->
<!--                        data-placement="top" data-tw-merge=""-->
<!--                        title="Enviar archivo"><i-->
<!--                  [class]="styleIconButtonSmall" data-lucide="file-text" data-tw-merge=""></i></button>-->
<!--                &nbsp;&nbsp;-->

<!--                <button (click)="TriggerFile(fileInput,false,true,false,false)" [class]="styleListSmallButtonRoundedPrimary" class="rounded-full"-->
<!--                        data-placement="top" data-tw-merge=""-->
<!--                        title="Enviar imagen"><i-->
<!--                  [class]="styleIconButtonSmall" data-lucide="image" data-tw-merge=""></i></button>-->
<!--                &nbsp;&nbsp;-->
<!--                <button (click)="TriggerFile(fileInput,false,false,true,false)" [class]="styleListSmallButtonRoundedPrimary" class="rounded-full"-->
<!--                        data-placement="top" data-tw-merge=""-->
<!--                        title="Enviar audio"><i-->
<!--                  [class]="styleIconButtonSmall" data-lucide="music" data-tw-merge=""></i></button>-->
<!--                &nbsp;&nbsp;-->

<!--                <button (click)="TriggerFile(fileInput,false,false,false,true)" [class]="styleListSmallButtonRoundedPrimary" class="rounded-full"-->
<!--                        data-placement="top" data-tw-merge=""-->
<!--                        title="Enviar video"><i-->
<!--                  [class]="styleIconButtonSmall" data-lucide="video" data-tw-merge=""></i></button>-->
<!--              </div>-->
<!--              <div class="col-span-11">-->
<!--              <textarea (keydown.control.enter)="EnviarMensaje()" [class]="styleTextareaChat" autosize data-tw-merge="" formControlName="inputMensaje"-->
<!--                        placeholder="Escriba su mensaje" rows="1"></textarea>-->
<!--                <input #fileInput (change)="VerificarArchivoBase64($event, MyFile)" formControlName="inputFile" hidden-->
<!--                       type="file">-->
<!--                <div-->
<!--                  *ngIf="Controls['inputMensaje'].invalid && (Controls['inputMensaje'].dirty || Controls['inputMensaje'].touched)"-->
<!--                  class="text-error">-->
<!--                  <div>Campo obligatorio.</div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="flex items-end">-->
<!--                &lt;!&ndash;<button data-tw-merge="" data-placement="top" title="Adjuntar archivo"-->
<!--                  [class]="styleListSmallButtonRoundedPrimary" class="rounded-full" (click)="fileInput.click()"><i-->
<!--                    data-tw-merge="" data-lucide="paperclip" [class]="styleIconButtonSmall"></i></button>-->
<!--                &nbsp;&nbsp;-->
<!--              &ndash;&gt;-->
<!--                <button (click)="EnviarMensaje()" [class]="styleListSmallButtonRoundedPrimary" class="rounded-full"-->
<!--                        data-placement="top" data-tw-merge="" title="Enviar mensaje"><i-->
<!--                  [class]="styleIconButtonSmall" data-lucide="send" data-tw-merge=""></i></button>-->
<!--              </div>-->
<!--            </div>-->


<!--            <ng-template #MyFile>-->
<!--              <div data-tw-merge="">-->
<!--                <a (click)="CerrarModal()" [class]="styleAX" href="javascript:">-->
<!--                  <i [class]="styleIconX" data-lucide="x" data-tw-merge></i>-->
<!--                </a>-->
<!--                <div [class]="styleDivHeaderModal">-->
<!--                  <h2 class="mr-auto text-base font-medium">-->
<!--                    ARCHIVO ADJUNTO-->
<!--                  </h2>-->
<!--                </div>-->
<!--                <div class="p-8 grid grid-cols-12 gap-4 gap-y-3" data-tw-merge="">-->
<!--                  <div *ngIf="isApplication" class="col-span-12">-->
<!--                    <div class="boton-download-file flex justify-center">-->
<!--                      <img class="width-50" src="../../assets/text-document.svg"/>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div *ngIf="isImage" class="col-span-12">-->
<!--                    <img [src]="archivoActual" class="image width-100"/>-->
<!--                  </div>-->
<!--                  <div *ngIf="isAudio" class="col-span-12 flex justify-center">-->
<!--                    <audio controls>-->
<!--                      <source [src]="archivoActual">-->
<!--                    </audio>-->
<!--                  </div>-->
<!--                  <div *ngIf="isVideo" class="col-span-12 flex justify-center">-->
<!--                    <video class="width-50" controls>-->
<!--                      <source [src]="archivoActual">-->
<!--                    </video>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;<div class="col-span-12 mb-3 mt-3">-->
<!--                    <strong>El tamaño máximo del archivo es {{tamanioImage}}-->
<!--                      MB.</strong>-->
<!--                  </div>&ndash;&gt;-->
<!--                  <div class="col-span-11">-->
<!--                  <textarea (keydown.control.enter)="EnviarMensaje()" [class]="styleTextareaChat" autosize data-tw-merge=""-->
<!--                            formControlName="inputMensaje"-->
<!--                            placeholder="Escriba su mensaje" rows="1"></textarea>-->
<!--                  </div>-->
<!--                  <div class="flex items-end">-->
<!--                    <button (click)="EnviarMensaje()" [class]="styleListSmallButtonRoundedPrimary" class="rounded-full"-->
<!--                            data-placement="top" data-tw-merge="" title="Enviar mensaje">-->
<!--                      <i-->
<!--                        [class]="styleIconButtonSmall" data-lucide="send" data-tw-merge=""></i></button>-->
<!--                  </div>-->
<!--                </div>-->
<!--                &lt;!&ndash;<div class="py-3 text-right border-t border-slate-200/60 dark:border-darkmode-400">-->
<!--                  <button data-tw-merge (click)="CerrarModal()" data-placement="top" title="Cerrar ventana" [class]="styleButtonDanger"> <i data-tw-merge-->
<!--                    data-lucide="x" [class]="styleIconButtonText"></i>-->
<!--                    Cerrar</button>-->
<!--                </div>&ndash;&gt;-->
<!--              </div>-->
<!--            </ng-template>-->

<!--          </form>-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash; END: Chat Active &ndash;&gt;-->
<!--    </div>-->
<!--    <div class="col-span-12 lg:col-span-2"></div>-->
<!--  </div>-->
<!-- END: Chat Content -->

<!-- BEGIN: Basic Card -->
<div class="mt-2 preview-component intro-y box">
  <div class="pt-5 col-span-12 sm:col-span-1 lg:col-span-1 flex justify-end">
    <button (click)="AbrirNuevoChat()" [class]="styleButtonSearch" data-tw-merge><i [class]="styleIconButtonText"
        data-lucide="plus" data-tw-merge></i>
      Nuevo
    </button>
  </div>
  <div class="p-5">
    <!-- BEGIN: Data List -->
    <form [formGroup]="dataFormGroupBusqueda" autocomplete="off" class="form" novalidate="novalidate">
      <div class="p-5 grid grid-cols-4 gap-4 gap-y-3" data-tw-merge="">
        <div class="col-span-12 sm:col-span-1 lg:col-span-1">
          <label [class]="styleLabel" data-tw-merge="">
            Nro. celular:
          </label>
          <div class="flex group input-group" data-tw-merge inputGroup="inputGroup">
            <div
              class="py-2 px-3 bg-slate-100 border shadow-sm border-slate-200 text-slate-600 dark:bg-darkmode-900/20 dark:border-darkmode-900/20 dark:text-slate-400 group-[.input-group]:rounded-none group-[.input-group]:[&:not(:first-child)]:border-l-transparent group-[.input-group]:first:rounded-l group-[.input-group]:last:rounded-r"
              data-tw-merge>
              +51
            </div>
            <input (keypress)="FiltrarNumeros($event)" [class]="styleInputText" data-tw-merge=""
              formControlName="inputNroCelular" maxlength="9" placeholder="Ingrese nro. celular." type="text">
          </div>

          <div
            *ngIf="ControlsBusqueda['inputNroCelular'].invalid && (ControlsBusqueda['inputNroCelular'].dirty || ControlsBusqueda['inputNroCelular'].touched)"
            class="text-error">
            <div>Campo obligatorio.</div>
          </div>
        </div>
        <div class="col-span-12 sm:col-span-1 lg:col-span-1">
          <label [class]="styleLabel" data-tw-merge="">
            Fecha inicio:
          </label>
          <dx-date-box [classList]="styleInputText" [showClearButton]="true" [useMaskBehavior]="true"
            displayFormat="shortdate" formControlName="inputFechaInicio" placeholder="dd/mm/aaaa" type="date">
          </dx-date-box>
          <div
            *ngIf="ControlsBusqueda['inputFechaInicio'].invalid && (ControlsBusqueda['inputFechaInicio'].dirty || ControlsBusqueda['inputFechaInicio'].touched)"
            class="text-error">
            <div>Campo obligatorio.</div>
          </div>
        </div>
        <div class="col-span-12 sm:col-span-1 lg:col-span-1">
          <label [class]="styleLabel" data-tw-merge="">
            Fecha fin:
          </label>
          <dx-date-box [classList]="styleInputText" [showClearButton]="true" [useMaskBehavior]="true"
            displayFormat="shortdate" formControlName="inputFechaFin" placeholder="dd/mm/aaaa" type="date">
          </dx-date-box>
          <div
            *ngIf="ControlsBusqueda['inputFechaFin'].invalid && (ControlsBusqueda['inputFechaFin'].dirty || ControlsBusqueda['inputFechaFin'].touched)"
            class="text-error">
            <div>Campo obligatorio.</div>
          </div>
        </div>
        <div class="col-span-12 sm:col-span-1 lg:col-span-1 flex items-end">
          <!--            <label class="inline-block mb-2"> &nbsp;-->
          <!--            </label>-->
          <!--            <br/>-->
          <button (click)="BuscarPorCriterio()" [class]="styleButtonSearch" data-tw-merge><i
              [class]="styleIconButtonText" data-lucide="search" data-tw-merge></i>
            Buscar
          </button>
          <button (click)="LimpiarFormularioBusqueda()" [class]="styleButtonDanger" data-tw-merge><i
              [class]="styleIconButtonText" data-lucide="eraser" data-tw-merge></i>
            Limpiar
          </button>
        </div>
      </div>
    </form>
    <div class="intro-y col-span-12 overflow-auto sm:overflow-visible">
      <dx-data-grid [dataSource]="listaObtenerDetalle" [remoteOperations]="true" [showBorders]="true"
        id="gridContainer">
        <dxi-column caption="Nro. cliente" dataField="numeroCliente" dataType="string" width="120"></dxi-column>
        <dxi-column dataField="fechaEnvio" dataType="date" width="120"></dxi-column>
        <dxi-column dataField="mensaje" dataType="string"></dxi-column>
        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-pager [allowedPageSizes]="[8, 12, 20]" [showPageSizeSelector]="true"></dxo-pager>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
      </dx-data-grid>
    </div>
    <!-- END: Data List -->
  </div>
</div>

<!-- END: Basic Card -->

<ngx-spinner [fullScreen]="true" bdColor="rgba(0, 0, 0, 0.8)" color="#fff" size="medium" type="square-jelly-box">
  <p style="color: white"> Espere un momento por favor... </p>
</ngx-spinner>
